import React, { Fragment } from 'react'
import { useNavigate } from 'react-router-dom'
import PropTypes from 'prop-types'
import Swal from 'sweetalert2'

import Dashboard from '@wrappers/Dashboard'
import { Title } from '@lib'
import TemplateFieldValueForm from '@shared/TemplateFieldValueForm'

const Content = ({ user }) => {
  const navigate = useNavigate()

  const handleSave = () => {
    navigate('/datalogic/template-settings#template-field-values')

    Swal.fire({
      text: 'Field allowed value added!',
      icon: 'success',
      showConfirmButton: false,
      timer: 3000
    })
  }

  return (
    <Fragment>

      <Title text='New Template Field Value' user={user}/>

      <TemplateFieldValueForm
        onSave={handleSave}
      />
    </Fragment>
  )
}

Content.propTypes = {
  user: PropTypes.object
}

const NewTemplateFieldValue = () => {
  return (
    <Dashboard>
      <Content />
    </Dashboard>
  )
}

export default NewTemplateFieldValue
